import React from 'react';
import ButtonLink from '../ButtonLink';
import { useI18n } from '../../../data/hooks/i18nHooks';

function InviteParticipantButton(props) {
    const { event, participant } = props,
        i18n = useI18n();

    return (
        <ButtonLink className="smallButton primary outline" href={'./invite?users=' + participant.user_id}>
            {i18n['label.send.invitation']}
        </ButtonLink>
    );
}

export default InviteParticipantButton;
